// in ActionProvider.jsx
import React from "react";
import { createChatBotMessage } from "react-chatbot-kit";

const ActionProvider = ({ createChatBotMessage, setState, children }) => {
  const handleHello = () => {
    const botMessage = createChatBotMessage("Hello. Nice to meet you.");

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  };

  const handleGaurav = () => {
    const botMessage = createChatBotMessage("Here is a picture of Gaurav", {
      widget: "Gaurav",
      payload: {}, // any value I want to send to the given widget or message
      delay: 3000,
    });

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  };

  // Put the handleHello function in the actions object to pass to the MessageParser
  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          actions: {
            handleHello,
            handleGaurav
          },
        });
      })}
    </div>
  );
};

export default ActionProvider;
